import mitt from 'mitt';

export const eventbus = mitt()